angular.module('mercury.modules.qa.menumate.salesline')
.controller('QaMenumateSalesLinesReportCtrl', ["$filter", "$http", "reporttime", "$scope", "title", "settings", function($filter, $http, reporttime, $scope, title, settings) {
  title.set('Sales Lines Report');

  $scope.loading = $http.get(settings.apiHost + '/r/PosQaMenumateSalesLine', {
    params: {
      startTime: reporttime.start(),
      endTime: reporttime.end()
    }
  });

  $scope.loading.then(function(response) {
    title.setSubheader(response.data.notes);
    $scope.dayGroups = {};
    angular.forEach(response.data.lines, function(line) {
      var key = moment(line.timeStamp).format('YYYY-MM-DD');
      if (!$scope.dayGroups[key]) {
        $scope.dayGroups[key] = [];
      }
      $scope.dayGroups[key].push(line);
    });

    $scope.allLines = response.data.lines;
  });
}]);
